export default "__VITE_ASSET__1374daad__"